<template>
  <b-row>
    <b-col md="12">
      <b-card>
        <b-row class="mb-2">
          <b-col md="10" />
          <b-col md="2">
            <b-button
              to="/hr/employees/add"
              variant="primary"
              block
            ><FeatherIcon icon="PlusIcon" />
              Ekle</b-button>
          </b-col>
        </b-row>
        <b-card-text>
          <b-table
            responsive="sm"
            :fields="fields"
            :items="dataList"
            striped
            fixed
          >
            <template #cell(title)="data">
              {{ data.item.name + ' ' + data.item.surname }}
            </template>
            <template #cell(phone_business)="data">
              {{ data.item.phone_business }}
            </template>
            <template #cell(ended)="data">
              <FeatherIcon
                v-if="!data.item.ended"
                icon="CheckIcon"
                size="20"
                class="text-success"
              />
              <FeatherIcon
                v-else
                icon="XIcon"
                size="20"
                class="text-danger"
              />
            </template>
            <template #cell(control)="data">
              <b-button
                :to="'/hr/employees/edit/' + data.item.id"
                variant="outline-primary"
                size="sm"
              >
                Görüntüle
              </b-button>
            </template>
          </b-table></b-card-text>
        <b-card-footer><b-pagination
          v-model="currentPage"
          :total-rows="dataCount"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination></b-card-footer>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BCard, BCardText, BRow, BCol, BTable, BCardFooter, BPagination, BButton,
} from 'bootstrap-vue'

export default {
  name: 'Index',
  components: {
    BCard,
    BCardText,
    BTable,
    BRow,
    BCol,
    BCardFooter,
    BPagination,
    BButton,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      fields: [
        {
          key: 'title',
          label: 'Personel',
        },
        {
          key: 'phone_business',
          label: 'Telefon (İş)',
        },
        {
          key: 'ended',
          label: 'Durum',
        },
        {
          key: 'control',
          label: 'Kontrol',
          thStyle: { width: '140px' },
        },
      ],
      dataQuery: {
        select: [
          'employees.id AS id',
          'employees.name AS name',
          'employees.surname AS surname',
          'employees.phone_business AS phone_business',
          'employees.ended AS ended',
        ],
        limit: 10,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['employees/getEmployees']
    },
    dataCount() {
      return this.$store.getters['employees/getEmployeesCount']
    },
  },
  watch: {
    currentPage(val) {
      const page = (val - 1) * 10
      this.pagination(page)
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    pagination(page) {
      this.dataQuery.start = page
      if (this.dataQuery.start === page) {
        this.getDataList()
      }
    },
    getDataList() {
      this.$store.dispatch('employees/employeesList', this.dataQuery)
    },
  },
}
</script>

<style scoped>

</style>
